import { Box, BoxProps } from '@mui/material';

type UtilityDrawerBodyProps = {
  children: React.ReactNode;
} & BoxProps;

const UtilityDrawerBody = ({ children, ...rest }: UtilityDrawerBodyProps) => {
  return (
    <Box
      display="flex"
      flexGrow="1"
      flexDirection="column"
      overflow="hidden"
      data-testid="IncDrawerBody"
    >
      <Box display="flex" flexGrow="1" flexDirection="column" overflow="auto">
        <Box px={[2, 3]} py={2} flex="1 0 auto" {...rest}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default UtilityDrawerBody;
